module.exports = __webpack_public_path__ + "media/3-12.6ff291f5.wav";